<template>
  <div class="typography-display-content" id="identidade-visual-tipografia-display" data-search-anchor>
    <div class="title-typography-display-wrapper">
      <h1 class="typography-display-span">{{ typographyAlignmentTitleSpan }}</h1>
      <h1 class="typography-display-title">{{ typographyAlignmentTitle }}</h1>
    </div>
    <div class="description-typography-display-wrapper">
      <p class="typography-display-description">{{ typographyAlignmentDescription }}</p>

      <p class="typography-display-description">{{ typographyAlignmentDescription1 }}</p>
    </div>
    <div
      class="typography-display-card-item"
      :style="{ backgroundImage: `url(${typographyAlignmentImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class TypographyDisplaySection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyAlignmentTitleSpan(): string {
    return this.getElementTitle(6, 0)
  }

  get typographyAlignmentTitle(): string {
    return this.getElementText(6, 0)
  }

  get typographyAlignmentDescription(): string {
    return this.getElementText(6, 1)
  }

  get typographyAlignmentDescription1(): string {
    return this.getElementText(6, 2)
  }

  get typographyAlignmentImageSrc(): string {
    return this.getElementMedia(6, 3)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typography-display-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-typography-display-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.typography-display-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typography-display-title { 
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-typography-display-wrapper { 
  position: relative;
  
  display: grid;
  grid-template-columns: 51.2% 48.8%;  
}

.typography-display-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin-top: 0;
  width: 430px;
}

.typography-display-card-item {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 710px;

  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
